// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** Description of the operation POST /v1/backoffice/logout */
export async function logout(options: { [key: string]: any } = {}) {
  return request<any>("/v1/backoffice/logout", {
    ...options,
    method: "POST",
  });
}

/** Get current authenticated user GET  */
export async function user(options: { [key: string]: any } = {}) {
  return request<{
    data: HubAPI.User;
  }>("/v1/backoffice/authorization/current-user", {
    ...options,
    method: "GET",
    skipErrorHandler: true,
    withCredentials: true,
  });
}

/** 获取通知列表 GET /v1/backoffice/authorization/notices */
export async function getNotices(options: { [key: string]: any } = {}) {
  return request<HubAPI.NoticeIconList>(
    "/v1/backoffice/authorization/notices",
    {
      ...options,
      method: "GET",
    }
  );
}



export async function getCurrentSettings(
  body: HubAPI.Settings,
  options: { [key: string]: any } = {}
) {
  return request<{ data: HubAPI.Settings }>(
    "/v1/backoffice/authorization/settings",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...options,
    }
  );
}

export async function updateSettingsLanguage(
  body: HubAPI.Settings,
  options: { [key: string]: any } = {}
) {
  return request<{ data: HubAPI.Settings }>(
    "/v1/backoffice/authorization/settings/language",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...options,
    }
  );
}

export async function updateSettingsLayout(
  body: HubAPI.Settings,
  options: { [key: string]: any } = {}
) {
  return request<{ data: HubAPI.Settings }>(
    "/v1/backoffice/authorization/settings/layout",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...options,
    }
  );
}


/** * Get Analysis Chart Data (Dashboard)
 * GET /v1/backoffice/authorization/cs-org/chart'
 */
export async function getAnalysisChartData(options: { [key: string]: any } = {}) {
  return request<{ data: HubAPI.DashboardAnalytics }>(
    "/v1/backoffice/authorization/cs-org/chart",
    {
      method: "GET",
      ...options,
    }
  );
}

export async function gatewayStatistics(options: { [key: string]: any } = {}) {
  return request<{ data: HubAPI.GatewayStatistics }>(
    "/v1/backoffice/authorization/x/feature/gateway/statistics",
    {
      method: "GET",
      ...options,
    }
  );
}


/** * Get Organization
 * POST /v1/backoffice/authorization/x/uni/organizations
 */
export async function queryOrganization(
  params: { id?: number; name?: string },
  options: { [key: string]: any } = {}
) {
  return request<{ data: HubAPI.OrganizationListItem[] }>(
    "/v1/backoffice/authorization/x/uni/organizations",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: {
        action: "query",
        page: 1,
        pageSize: 1,
        search: params.name || "",
        filter: params.id ? { id: params.id } : {},
      },
      ...options,
    }
  );
}
